import request from '../../library/request';

export const updateEventDetails = async (eid, fields,callBack) => {
    let res = await request('preparingEvent.updateEventDetails', 'put', `/event/${eid}`, fields);
    callBack(res);
};
